// extracted by mini-css-extract-plugin
export default {"time-logs-header":"Header_time-logs-header__usDCj","time-logs-header-item":"Header_time-logs-header-item__mkBL5"};